import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api, type QuotePayload } from '@/lib/api';

/** Note de la commande (instructions de livraison, n° de bon de commande du client…). */
export default function OrderNote({
  data,
  onChange,
}: {
  data: QuotePayload;
  onChange: (d: QuotePayload) => void;
}) {
  const { quote } = data;
  const editable = quote.status === 'DRAFT';
  const [note, setNote] = useState(quote.note ?? '');
  useEffect(() => setNote(quote.note ?? ''), [quote.note]);

  const saveNote = useMutation({
    mutationFn: () =>
      api<QuotePayload>(`/api/quotes/${quote.id}`, {
        method: 'PATCH',
        body: JSON.stringify({ note: note.trim() || null }),
      }),
    onSuccess: onChange,
  });

  return (
    <section className="panel p-4">
      <label className="block space-y-1">
        <span className="panel-title">Note de commande</span>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          onBlur={() => note !== (quote.note ?? '') && saveNote.mutate()}
          disabled={!editable}
          rows={2}
          maxLength={2000}
          placeholder="Ex. : livraison jeudi, n° de bon de commande du client…"
          className="border-input bg-card focus:border-primary focus:ring-primary/15 w-full rounded-lg border px-3 py-2 text-base focus:ring-4 focus:outline-none"
        />
      </label>
      {saveNote.isError && <p className="text-destructive text-sm">{(saveNote.error as Error).message}</p>}
    </section>
  );
}
